const $ = window.$;
export default $;


// WEBPACK FOOTER //
// ./web/js/alias/jquery.js